import { get } from 'vuex-pathify';
export default {
  computed: {
    isBufferModuleEnabled: get('admin/additionalModules@BUFFER.enabled'),
    hasBufferPermissions() {
      return this.$store.get('users/toolsPermissions')['BUFFER'].main_value > 0;
    },
    isBufferVisible() {
      return this.isBufferModuleEnabled && this.hasBufferPermissions && this.hasGeometry;
    },
    bufferButton() {
      return this.isBufferVisible
        ? [
            {
              name: 'buffer',
              icon: 'mdi-map-marker-circle',
              tooltip:
                this.isAnyFeatureSelected && this.currentLayerSelectedFeatures?.length <= 5000
                  ? this.$i18n.t('button.buffer')
                  : this.$i18n.t('button.toBuffer', {
                      suffix:
                        this.currentLayerSelectedFeatures?.length > 5000
                          ? this.$i18n.t('button.maxNumberSelected', { value: 5000 })
                          : this.$i18n.t('button.atLeastOneSelected'),
                    }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected || this.currentLayerSelectedFeatures?.length > 5000,
            },
          ]
        : [];
    },
  },
  methods: {
    bufferAction() {
      this.$router.push({ name: 'buffer', params: { lid: this.currentLayer?.id } });
    },
  },
};
